import { render, staticRenderFns } from "./EscrowCompanies.vue?vue&type=template&id=4b606c36&scoped=true&"
import script from "./EscrowCompanies.vue?vue&type=script&lang=js&"
export * from "./EscrowCompanies.vue?vue&type=script&lang=js&"
import style0 from "./EscrowCompanies.vue?vue&type=style&index=0&id=4b606c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b606c36",
  null
  
)

export default component.exports